<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';

const props = defineProps<{
  modelValue: string | number;
  value: string | number;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | number];
}>();

const selection = useVModel(props, 'modelValue', emit);
const isSelected = computed(() => props.modelValue === props.value);
</script>

<template>
  <span
    class="relative inline-flex px-3 py-1.5 border border-solid rounded-md h-14"
    :class="
      isSelected
        ? 'bg-neutral-100 border-black'
        : 'bg-white border-nuts-neutral-200 hover:bg-zinc-50'
    "
  >
    <label class="flex w-full cursor-pointer" data-test="variant-option">
      <input
        v-model="selection"
        :aria-label="`variant-option-${value}`"
        class="absolute top-0 bottom-0 left-0 right-0 w-full h-full p-0 m-0 rounded-md appearance-none cursor-pointer"
        :id="`variant-${value}`"
        name="variant"
        type="radio"
        :value="value"
      />
      <slot />
    </label>
  </span>
</template>
